import React, { createContext, useContext, useState } from "react";
import format from 'date-fns/format';

const YearContext = createContext();

export function YearProvider({ children }) {
    const currentYear = new Date().getFullYear();
    const startOfYear = new Date(currentYear, 0, 1);
    const endOfYear = new Date(currentYear, 11, 31);
    
  const [selectedYear, setSelectedYear] = useState([
    {
        startDate: startOfYear,
        endDate: endOfYear,
        key: 'selection',
        dateString: `${format(startOfYear, 'yyyy-MM-dd') + '..' + format(endOfYear, 'yyyy-MM-dd')}`,
        currentYear: currentYear
    }
  ]);

  return (
    <YearContext.Provider value={{ selectedYear, setSelectedYear }}>
      {children}
    </YearContext.Provider>
  );
}

export function useYear() {
  return useContext(YearContext);
}
